import { render, staticRenderFns } from "./pathology.vue?vue&type=template&id=554db3ae&scoped=true"
import script from "./pathology.vue?vue&type=script&lang=js"
export * from "./pathology.vue?vue&type=script&lang=js"
import style0 from "./pathology.vue?vue&type=style&index=0&id=554db3ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554db3ae",
  null
  
)

export default component.exports